/* src/app/admin-dashboard/regulering/regulering.component.css */
.example-full-width {
  width: 100%;
}
.buttons {
  margin-top: 20px;
}
/*# sourceMappingURL=regulering.component.css.map */
